import(/* webpackMode: "eager" */ "/root/ophirstudio_next/app/[lang]/services/vr-training-and-simulation/components/Point.tsx");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/app/[lang]/services/vr-training-and-simulation/components/UseCase.tsx");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/app/[lang]/services/vr-training-and-simulation/style.scss");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/digital-twins-custom-environments.jpg");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/enhanced-experiential-learning.jpg");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/faster-onboarding-and-skill-development.jpg");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/fewer-operational-errors.jpg");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/grayscale_logo.png");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/header.jpg");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/machinery-equipment-simulations.jpg");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/maintenance-troubleshooting-simulations.jpg");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/no-downtime-required.jpg");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/production-line-assembly-training.jpg");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/risk-free-controlled-environments.jpg");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/safety-emergency-response.jpg");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/public/assets/services/vr-training/standardized-procedures-across-teams-and-sites.jpg");
